/* eslint-disable @typescript-eslint/naming-convention */
import {Component, Inject, Input, OnInit, Renderer2} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {LogService} from '@app/services/log.service';
import {LogLevel, LogResource} from '@app/modules/shared/data/constants';

@Component({
  selector: 'app-smartsupp',
  templateUrl: './smartsupp.component.html'
})
export class SmartsuppComponent implements OnInit {
  private _name: string;
  private _username: string;
  private _alignX = 'left';

  constructor(private _renderer2: Renderer2, @Inject(DOCUMENT) private _document: Document) {}

  public ngOnInit(): void {
    const script = this._renderer2.createElement('script');
    script.type = `application/javascript`;
    script.text = `
      var CALL_TIME = {};

      <!-- Smartsupp Live Chat script -->
      var _smartsupp = _smartsupp || {};
      _smartsupp.key = 'ee8b4eaa1be169b352eab54c0b6edbb0fbbdc24f';
      _smartsupp.orientation = '${this._alignX}';
      window.smartsupp || (function (d) {
        // noinspection JSUndeclaredVariable
        var s, c, o = smartsupp = function () {
          o._.push(arguments)
        };
        o._ = [];
        s = d.getElementsByTagName('script')[0];
        c = d.createElement('script');
        c.type = 'text/javascript';
        // noinspection JSDeprecatedSymbols
        c.charset = 'utf-8';
        c.async = true;
        c.src = '//www.smartsuppchat.com/loader.js?';
        s.parentNode.insertBefore(c, s);
      })(document);
    `;

    this._renderer2.appendChild(this._document.body, script);
    window.smartsupp('chat:close');
  }
  @Input() public set alignX(value: string) {
    this._alignX = value;
  }
  @Input() public set username(value: string) {
    if (value) {
      setTimeout(() => {
        this._username = value;
        window.smartsupp('name', this._username);
        LogService.writeLog(`Smartsupp user support name is set to ${this._username}`, LogLevel.INFO, LogResource.CORE);
      }, 2000);
    }
  }
  @Input() public set name(value: string) {
    if (value) {
      setTimeout(() => {
        this._name = value;
        const variables = {Username: this._name, 'Diagnostics Report Page': 'https://diagnostics.russianschool.com/diagnostics/report?name=' + encodeURIComponent(this._name)};
        window.smartsupp('variables', variables);
        LogService.writeLog(`Smartsupp user name is set to ${variables.Username}`,
          LogLevel.INFO,
          LogResource.CORE
        );
      }, 2000);
    }
  }
}
